/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// styles
import injectSheet from 'react-jss';
import theme from 'material/dropdowns/dropfilter/dropdownitem/dropdownitem_styles';
import Icon from 'material/graphic/icon/icon';



/* ========== ~~~~~~~~~~ Filter : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
const DropDownItem =(props)=> {

	const handleClick = e =>{
		props.itemSelected ? props.handleDeselect(props.value) : props.handleSelect(props.value);
	};

   const renderItemText = ()=>{
        let item = props.item;
        let searchText = props.searchTerm;

        let beginningText = item.slice(0,item.toLowerCase().indexOf(searchText.toLowerCase()));
        let highlightedText = item.slice(item.toLowerCase().indexOf(searchText.toLowerCase()), item.toLowerCase().indexOf(searchText.toLowerCase())+searchText.length);
        let endingText = item.slice(item.toLowerCase().indexOf(searchText.toLowerCase())+searchText.length, item.length);
        return <div className={`item`}><span>{beginningText}</span><span className={`highlight`} >{highlightedText}</span><span>{endingText}</span> </div>
    };
    const renderCheck = () =>  <Icon name={`check`}/> ;

        let {itemSelected} = props;
		return (
	        <div onClick={handleClick} className={`dropDownItem ${props.classes.dropDownItem} active-${itemSelected}`}>
                {renderCheck()}
				{renderItemText()}
	        </div>
		);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(theme)(DropDownItem);